import { useEffect, useState } from 'react';
import './team-view.styles.scss';
import { useLocation, useParams } from 'react-router-dom';
import { completePlayerData } from '@/components/PREVIEW/previewPlayers';
import TeamViewContent from './team-view-content.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { useGameTerms } from '@/utils/gameTerms';

const TeamView = ({
  gameData,
  playerList,
  teamList,
  isManager
}) => {

  const { teamPath } = useParams();
  const [teamData, setTeamData] = useState(null);
  const terms = useGameTerms();
  const location = useLocation();

  const isPreview = location.pathname.includes('/preview/manager/');

  useEffect(() => {
    if (!teamPath || !teamList) return;
    console.log(teamPath);
    getTeamData();

    function getTeamData() {
      if (isPreview) {
        if (!completePlayerData) return;
        const teamInfo = Object.values(completePlayerData)
          .find(p => p.path === teamPath);
        setTeamData(teamInfo);
        return;
      }
      setTeamData(Object.values(teamList).find(t => t.path === teamPath));
    }
  }, [teamPath, teamList, isPreview])

  useEffect(() => {
    if (!gameData?.gameName || !teamData?.name) return;
    changeDocumentTitle(`${terms.team.singular}: ${teamData?.name ?? ''} | Manage ${gameData.gameName ?? 'Game'}`);
  }, [gameData?.gameName, teamData?.name, terms])



  return (
    <div className='team-view-container'>
      {
        teamData &&
        <TeamViewContent
          gameData={gameData}
          teamData={teamData}
          playerList={playerList}
          isManager={isManager} />
      }
    </div>
  )
}

export default TeamView